import React, { ReactNode } from 'react';
import { Content } from './Content';
import Toolbar from './Toolbar';

type Props = {
  title?: string;
  icon?: string;
  toolbarChildren?: ReactNode;
};

const Page: React.FC<Props> = ({ title, icon, children, toolbarChildren }) => {
  return (
    <div id='kt_content' className='content d-flex flex-column flex-column-fluid'>
      <Toolbar title={title} icon={icon}>
        {toolbarChildren}
      </Toolbar>
      <div className='post d-flex flex-column-fluid' id='kt_post'>
        <Content>{children}</Content>
      </div>
    </div>
  );
};

export default Page;
